var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background",style:(_vm.backgroundStyle)},[_c('slide-y-up-transition',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }